module.exports = __webpack_public_path__ + "static/media/S (10).eec899d9.jpg";